import { createClient } from '@supabase/supabase-js';
import { SUPABASE_PUBLIC_KEY, SUPABASE_URL } from 'src/env';

if (!SUPABASE_URL || !SUPABASE_PUBLIC_KEY) {
  throw new Error('Missing env variables for Supabase');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLIC_KEY);
